import { render, staticRenderFns } from "./assistantModal.vue?vue&type=template&id=2af5b88c&scoped=true&"
import script from "./assistantModal.vue?vue&type=script&lang=js&"
export * from "./assistantModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2af5b88c",
  null
  
)

export default component.exports